export const locale = {
  lang: 'nl',
  data: {
    PROSPECT: {
      CREATE: 'Nieuwe prospect',
      USERS: 'Gebruikers',
      NEW_USER: 'Nieuwe gebruiker',
      ALL_USERS: 'Alle gebruikers',
      FIRST_NAME: 'Voornaam',
      MIDDLE_NAME: 'Tussenvoegsel',
      LAST_NAME: 'Achternaam',
      ROLE: 'Rol',
      PHONE: 'Mobiel nummer',
      STATES: 'Status',
      PROSPECT: 'Prospect',
      ACTIVE: 'Actief',
      BLOCKED: 'Geblokkkeerd',
      INVITED: 'Uitgenodigd',
      ADMIN: 'Administrator',
      USER: 'Gebruiker',
      REVIEWER: 'Reviewer',
      STREET: 'Straat',
      NAME: 'Bedrijfsnaam',
      NUMBER: 'Nummer',
      NUMBER_ADD: 'Toev.',
      ZIPCODE: 'Postcode',
      CITY: 'Plaats',
      COUNTRY: 'Land',
      EMAIL: 'E-mail',
      PHONE_NUMBER: 'Telefoonnummer',
      MOBILE_NUMBER: 'Mobiel nummer',
      COC_NUMBER: 'KVK',
      VAT_NUMBER: 'BTW-nummer',
      SBI: 'Standaard bedrijfsindeling (SBI)',
      IBAN: 'IBAN',
      BIC: 'BIC',
      SAVE: 'Opslaan',
      GENDER: 'Geslacht',
      ORIGIN: 'Herkomst',
      DATE_OF_BIRTH: 'Geboortedatum',
      MALE: 'Man',
      FEMALE: 'Vrouw',
      PERSON: 'Persoon',
      PROSPECT_SAVED: 'Prospect opgeslagen',
      PROSPECT_SAVE_FAILED: 'Prospect opslaan mislukt',
      LEGAL: 'Rechtsvorm',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/main/content/prospect/i18n/nl.ts